module.exports = __webpack_public_path__ + "img/元数据.255674e2.svg";